import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import ModulesTable from '../QCTOModule/ModulesTable';
import EnhancedToolbar from '../../../widgets/Toolbar';
import QCTOModuleSetupSearch from '../QCTOModule/QCTOModuleSetupSearch';
import LinkDialog from "../../LinkDialog";
import ViewUtils from "./../../../ViewUtils";
import { ViewContainer } from "./../../../View.jsx";
import Prompt from '../../../widgets/Prompt';
import AlertItem from "../../../widgets/AlertItem";
import withMenuPermission from "../../../widgets/withMenuPermission";


const utils = new ViewUtils();

const headCells = [
    { id: 'ModuleCode', numeric: false, disablePadding: true, label: 'Module Code' },
    { id: 'ModuleTitle', numeric: false, disablePadding: true, label: 'Module Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'NQFLevel', numeric: false, disablePadding: true, label: 'NQF Level' },
    { id: 'LearningType', numeric: false, disablePadding: true, label: 'Learning Type' },
    { id: 'ModuleType', numeric: false, disablePadding: true, label: 'Module Type' }
];

const toolbarRef = React.createRef();

class QCTOSkillsProgrammeModuleSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linkDialogOpen: false,
            selectedLinkType: null,
            selectedLinkModules: null,
            selectedModule: null,
            keyUpSwitch: false,
            propmtOpen: false,
            promptTitle: "Unlink QCTO Module From QCTO Skills Programme",
            promptContent: "Are you sure you want to unlink this QCTO Module from the QCTO skills programme?",
            message: "",
            messageStyle: "",
            searchParameters: [{ Name: "skillsID", Value: props.location.state.skillsID }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {
                            contextMenu: [
                                { id: 1, description: "Core" },
                                { id: 2, description: "Elective" }
                            ],
                            id: 'link', label: 'Link', contextIcon: 'LinkIcon', tooltip: 'Link the selected QCTO Module to the QCTO skills programme', visible: this.props.menuPermissionItem.Add
                        },
                        { id: 'unlink', label: 'UN-LINK', icon: 'LinkOffIcon', tooltip: 'Un-link the selected QCTO Module from the QCTO skills programme', visible: this.props.menuPermissionItem.Delete, disabled: utils.isNull(this.state.selectedModule) }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/qctoSkillsProgrammeSetup',
                state: { selection: this.props.location.state.skillsID }
            });
        } else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedModule: null,
                selectedLinkType: null,
                selectedLinkModules: null,
                selectedModule: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }


    unlinkModule(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedModule}&skillsProgrammeId=${this.props.location.state.skillsID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, null);
    }

    handleToolbarButtonMenuClick(menu) {
        this.setState({ linkDialogOpen: true, selectedLinkType: menu });
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedModule: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedModule: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        }
        else {
            this.setState({
                selectedModule: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer>
                <p className="breadcrumbs">
                    {"QCTO Skills Programme > QCTO Modules"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <div className="searchResults">
                    <EnhancedToolbar highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)}
                        config={this.toolbarConfig} />
                    <ModulesTable headCells={headCells} onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/QCTOSkillsProgrammeSetupModule/GetSearch"
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.SkillsTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link QCTO Modules to QCTO Skills Programme: ${this.props.location.state.SkillsTitle}`}
                    linkName={"QCTOModules"} postUrl={"api/sims/QCTOSkillsProgrammeSetupModule/linkModules"} usePost={true}
                    programmeId={this.props.location.state.skillsID} programmeType="S"
                >
                    <QCTOModuleSetupSearch dataUrl="api/sims/QCTOSkillsProgrammeSetupModule/GetSearchLinkableModules"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.skillsID} programmeType="S"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkModule(`api/sims/qctoSkillsProgrammeSetupModule/unlinkSkillsProgrammeModule`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(QCTOSkillsProgrammeModuleSearch));
